import React from 'react';
import PositionOnlyPopperPopover from '@wix/da-ds/pkg/popper/presets/PositionOnlyPopperPopover';
var PopoverPopover = function (_a) {
    var contentClassName = _a.contentClassName, referenceClassName = _a.referenceClassName, children = _a.children, _b = _a.tooltipOffset, tooltipOffset = _b === void 0 ? [0, 8] : _b, placement = _a.placement, secondaryPlacement = _a.secondaryPlacement, onClose = _a.onClose, onReferenceClick = _a.onReferenceClick, renderPopover = _a.renderPopover, renderReference = _a.renderReference;
    return (React.createElement(PositionOnlyPopperPopover, { className: referenceClassName, placement: placement, secondaryPlacement: secondaryPlacement, isVisible: true, onClickOutside: onClose, offsetModifier: tooltipOffset, contentClassName: contentClassName, onReferenceClick: onReferenceClick, popoverContent: function () {
            return renderPopover &&
                renderPopover({
                    closeTooltip: onClose,
                });
        }, renderReference: renderReference }, children));
};
PopoverPopover.displayName = 'PopoverPopover';
export default PopoverPopover;
//# sourceMappingURL=PopoverPopover.js.map